module.exports = __webpack_public_path__ + "media/honey-icons/icon-boost-5eec6dce.svg";